import { render } from "./BaseFileupload.vue?vue&type=template&id=721b025a"
import script from "./BaseFileupload.vue?vue&type=script&lang=js"
export * from "./BaseFileupload.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__